/**
 * Navigation
 * ------------------------------------------------------------------------------
 * This file handles all interactions on mobile & desktop.
 *
 * @namespace custom
 */

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

custom.navigation = (() => {
  const breakpoint = 1080;

  // Caches
  const $navigation = $('.js-navigation');
  const $primary = $navigation.find('.navigation__primary');
  const $triggers = $navigation.find(
    '.navigation__link--has-sub > a, .navigation__link--has-sub > button',
  );
  const $primaryLinks = $navigation.find('.navigation__primary-link > a');
  const $utilitiesLinks = $navigation.find('.navigation__utilities-link > a');
  const $cartContainer = $('#cartMiniContainer');
  const $body = $('body');

  //Announcement bar classes
  const closeAnnouncementClass = 'js-close-announcement';
  const announcementClass = 'has-announcement';
  const announcementBarId = 'announcementBar';

  // Mobile Menu Open Class Name
  const mobileOpenClass = 'js-navigation-mobile-open';

  // Utilities Dropdown Class Names
  const utilNavClass = 'js-utilities-dropdown';
  const utilNavClassOrders = 'js-utilities-dropdown-orders';

  const utilNavHiddenClass = 'navigation__utilities-dropdown--hidden';
  const utilNavActiveClass = 'navigation--util-active';

  const quickCartHideClass = 'quick-cart--hide';

  // Back Button Class Names
  const backBtnClass = 'navigation__back';

  // Transparency handler variables
  const transparentPageClasses = [
    'page-virtual-market',
    'page-category-wall-art',
    'page-highpoint',
    'page-highpoint-json',
    'page-ota-landing',
    'page-corporate-social-responsibility',
    'page-las-vegas-market',
  ];
  const transparentComponents =
    '.hero, .hero-small, .js-quick-view-container, .hero-wall-art';
  const transparentClass = 'navigation--transparent';

  // Primary link color
  const primaryLinkBlurClass = 'navigation__primary-link--blur';
  const utilitiesLinkBlurClass = 'navigation__utilities-link--blur';

  let announcementBarHeight;
  let position;

  /**
   * Helpers
   */

  // Checks whether mobile or not
  function isMobile() {
    return (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < breakpoint
    );
  }

  function closeMiniCart() {
    if (!$cartContainer.hasClass(quickCartHideClass)) {
      removeUtilActive();
      $cartContainer.addClass(quickCartHideClass);
    }
  }

  // Has transparency navigation or not
  function isTransparentPage() {
    //if hero-overlay is present
    if ($('.hero-overlay').length > 0) return true;
    if ($('.hero-overlay-mobile').length > 0 && isMobile()) return true;
    //else if its a transparent page
    return transparentPageClasses.filter((className) => {
      if ($('body').hasClass(className)) return true;
    })[0];
  }

  function collaborationLink() {
    $('.navigation__tertiary button').on('click', function () {
      var targetUrl = $(this).data('grandchild-url');
      if (!targetUrl) return;
      window.location.href = $(this).data('grandchild-url');
      $(window).trigger('load');
      if (isMobile()) togglePanel();
    });
  }

  function togglePanel() {
    if (!$body.hasClass(mobileOpenClass)) {
      $body.addClass(mobileOpenClass);
      disableBodyScroll(
        document.querySelector('.js-navigation .navigation__primary'),
        {
          allowTouchMove: (el) => {
            while (el && el !== document.body) {
              if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                return true;
              }

              el = el.parentElement;
            }
          },
        },
      ); // Lock body Element
      $('.navigation__primary').addClass('current-open');
      custom.SearchPanel.closePanel();
      hideAllAnnouncements();
    } else {
      $navigation.removeClass(
        'navigation--open-secondary navigation--open-tertiary',
      );
      $body.removeClass(mobileOpenClass);
      $('ul.navigation__secondary')
        .removeClass('open')
        .removeClass('current-open');
      $('ul.navigation__tertiary')
        .removeClass('open')
        .removeClass('current-open');
      $('.navigation__primary').removeClass('current-open');
      showAllAnnouncements();
      clearAllBodyScrollLocks();
    }
  }

  /**
   * There are certain areas of the navigation that is nested within each other
   * but positioned side by side. For that reason we cannot apply overflow-y-scroll
   * by default because it will not show the menus which are nested. Overflow needs
   * to be applied dynamically. The delay allows for the transitions to finish.
   */
  const applyOverflowTimeout = ($el) => {
    setTimeout(() => {
      $el.addClass('overflow-hidden overflow-y-scroll');
    }, 300);
  };

  function closePanel(panelTrigger) {
    if ($body.hasClass(mobileOpenClass)) {
      $navigation.removeClass(
        'navigation--open-secondary navigation--open-tertiary',
      );
      $body.removeClass(mobileOpenClass);
      clearAllBodyScrollLocks();

      // if opening login panel while nav is still open in mobile
      if (!$(panelTrigger).hasClass('js-search-panel-trigger')) {
        $body.addClass('overflow-hidden');
        applyOverflowTimeout($('.mfp-container'));
      }
    }
  }

  function unlockBodyScroll() {
    if ($body.hasClass('overflow-hidden')) $body.removeClass('overflow-hidden');
    if ($('.mfp-container').length > 0)
      $('.mfp-container').removeClass('overflow-hidden overflow-y-scroll');
  }

  function openChildPanel(event = null) {
    if (
      !isMobile() &&
      !$(event.currentTarget).hasClass('js-navigation-link-off')
    )
      return;

    // if account and/or mini cart is open
    // on tablet or above, then close
    if (!isMobile()) {
      closeUtilDropdown();
      closeMiniCart();
    }

    event.preventDefault();
    var target = $(event.currentTarget).data('target-panel');
    var $panel = $('[data-panel="' + target + '"]');
    var isSecondary = $panel.hasClass('navigation__secondary');
    var isDesktop = !isMobile() || event.type == 'mouseenter';

    if (isSecondary && !isDesktop) {
      $('.navigation__primary').removeClass('current-open');
      $panel.addClass('open').addClass('current-open');
      applyOverflowTimeout($panel);
      $navigation.addClass('navigation--open-secondary');
    } else if (!isDesktop) {
      $('.navigation__secondary.current-open').removeClass('current-open');
      setTimeout(() => {
        $('.navigation__secondary.open').removeClass(
          'overflow-hidden overflow-y-scroll',
        );
      }, 100);
      $panel.addClass('open').addClass('current-open');
      $navigation.addClass('navigation--open-tertiary');
    } else if (isSecondary && isDesktop) {
      closeDropDown();
      $panel.addClass('open');
      // used by the panel's max-height so it ends at 90vh
      $panel[0].style.setProperty(
        '--nav-dropdown-top',
        `${Math.round($panel[0].getBoundingClientRect().top)}px`,
      );
      $navigation.addClass('navigation--open-dropdown');
    }
  }

  function primaryLinkColorHandler(event = null) {
    if (
      event.type === 'click' &&
      !$(event.currentTarget).hasClass('js-navigation-link-off')
    )
      return;
    event.preventDefault();
    const isDesktop = !isMobile() || event.type == 'mouseenter';
    if (isDesktop) {
      $(this).removeClass(primaryLinkBlurClass); // need this for About link
      $primaryLinks.not(this).addClass(primaryLinkBlurClass);
      $utilitiesLinks.not(this).addClass(utilitiesLinkBlurClass);
    } else {
      $primaryLinks.removeClass(primaryLinkBlurClass);
      $utilitiesLinks.removeClass(utilitiesLinkBlurClass);
    }
  }

  function closeDropDown(event = null) {
    if (isMobile()) return;
    $('.navigation__secondary.open')
      .removeClass('open')
      .removeClass('current-open');

    $navigation.removeClass('navigation--open-dropdown');
    // remove blur class from primary link listener
    if ($primaryLinks.hasClass(primaryLinkBlurClass)) {
      $primaryLinks.removeClass(primaryLinkBlurClass);
      $utilitiesLinks.removeClass(utilitiesLinkBlurClass);
    }
  }

  /**
   * While a desktop dropdown is open, wheel events over the header scroll the
   * open panel (when it can scroll) and never the page behind it.
   */
  function containDropdownWheel(event) {
    if (isMobile() || !$navigation.hasClass('navigation--open-dropdown'))
      return;
    const panel = event.target.closest('.navigation__secondary.open');
    if (panel) {
      const { scrollTop, scrollHeight, clientHeight } = panel;
      const canScrollUp = event.deltaY < 0 && scrollTop > 0;
      const canScrollDown =
        event.deltaY > 0 && scrollTop + clientHeight < scrollHeight - 1;
      if (canScrollUp || canScrollDown) return;
    }
    event.preventDefault();
  }

  function backToPrevPanel(event = null) {
    event.preventDefault();
    if (!isMobile()) return;

    const isTertiary = $('.js-navigation')
      .first()
      .hasClass('navigation--open-tertiary');
    const handler = (level) => () => {
      $(`.navigation__${level}.open`)
        .removeClass('open')
        .removeClass('current-open');

      if (level === 'tertiary') {
        $('.navigation__secondary.open').addClass('current-open');
        applyOverflowTimeout($('.navigation__secondary.open'));
      } else {
        $('.navigation__primary').addClass('current-open');
      }
      $navigation.removeClass(`navigation--open-${level}`);
    };

    return isTertiary ? handler('tertiary')() : handler('secondary')();
  }

  // Remove Transparent and goes back w/ white background
  function removeTransparent() {
    if ($navigation.hasClass(transparentClass))
      $navigation.removeClass(transparentClass);
  }

  // Apply Transparent class to navigation
  function applyTransparent() {
    if (!$navigation.hasClass(transparentClass))
      $navigation.addClass(transparentClass);
  }

  // Remove Hidden Class from dropdown DOM
  function openUtilDropdown(orders) {
    removeTransparent();
    addUtilActive();
    if (!isMobile()) {
      $primaryLinks.addClass(primaryLinkBlurClass);
      $utilitiesLinks.addClass(utilitiesLinkBlurClass);
    }
    if (!orders) {
      if (
        $(`.${utilNavClass} .navigation__utilities-dropdown`).hasClass(
          utilNavHiddenClass,
        )
      ) {
        $(`.${utilNavClass} .navigation__utilities-dropdown`).removeClass(
          utilNavHiddenClass,
        );
        if (
          !$(
            `.${utilNavClassOrders} .navigation__utilities-dropdown--orders`,
          ).hasClass(utilNavHiddenClass)
        ) {
          $(
            `.${utilNavClassOrders} .navigation__utilities-dropdown--orders`,
          ).addClass(utilNavHiddenClass);
        }
      }
    } else {
      if (
        $(
          `.${utilNavClassOrders} .navigation__utilities-dropdown--orders`,
        ).hasClass(utilNavHiddenClass)
      ) {
        $(
          `.${utilNavClassOrders} .navigation__utilities-dropdown--orders`,
        ).removeClass(utilNavHiddenClass);
        if (
          !$(`.${utilNavClass} .navigation__utilities-dropdown`).hasClass(
            utilNavHiddenClass,
          )
        ) {
          $(`.${utilNavClass} .navigation__utilities-dropdown`).addClass(
            utilNavHiddenClass,
          );
        }
      }
    }
  }

  function utilDropdownHandler(orders) {
    // if main nav and/or mini cart is open
    // on tablet or above, then close
    if (!isMobile()) {
      closeDropDown();
      closeMiniCart();
    }
    openUtilDropdown(orders);
  }

  // Add Hidden Class from dropdown DOM
  function closeUtilDropdown() {
    removeUtilActive();
    $primaryLinks.removeClass(primaryLinkBlurClass);
    $utilitiesLinks.removeClass(utilitiesLinkBlurClass);
    if (
      !$(`.${utilNavClass} .navigation__utilities-dropdown`).hasClass(
        utilNavHiddenClass,
      )
    ) {
      $(`.${utilNavClass} .navigation__utilities-dropdown`).addClass(
        utilNavHiddenClass,
      );
    }
    if (
      !$(
        `.${utilNavClassOrders} .navigation__utilities-dropdown--orders`,
      ).hasClass(utilNavHiddenClass)
    ) {
      $(
        `.${utilNavClassOrders} .navigation__utilities-dropdown--orders`,
      ).addClass(utilNavHiddenClass);
    }
  }

  function addUtilActive() {
    if (!$navigation.hasClass(utilNavActiveClass))
      $navigation.addClass(utilNavActiveClass);
  }
  function removeUtilActive() {
    $navigation.removeClass(utilNavActiveClass);
  }

  const heroPastHandler = custom.utils.debounce(function () {
    if (!document.querySelector(transparentComponents)) return;
    const hero = document.querySelector(transparentComponents);
    hero.getBoundingClientRect().bottom < 0
      ? removeTransparent()
      : applyTransparent();
  }, 100);

  // if main nav and/or util dropdown is open
  // on tablet or above, then close
  function closeNavAndUtilDropdown() {
    if (!isMobile()) {
      closeDropDown();
      closeUtilDropdown();
    }
  }

  /*
   * showAnnouncementBar
   * Set announcement bar to be shown if present
   *
   */
  function checkAnnouncementBar() {
    //Only needs to run when announcement bar is present.
    if ($(`#${announcementBarId}`).length) {
      const hiddenAnnouncementBar = sessionStorage.getItem(
        'hiddenAnnouncementBar',
      );
      if (hiddenAnnouncementBar) {
        hideAnnouncementBar();
      } else {
        $('body').addClass(`${announcementClass}`);
        $(`#${announcementBarId}`).removeClass('hide');
        $(`.${closeAnnouncementClass}`).on('click', hideAnnouncementBar);
      }
    }
  }

  /*
   * hideAnnouncementBar
   * Set announcement bar to be hidden, save preference to session storage
   *
   */
  function hideAnnouncementBar() {
    const setNavHeight = !isMobile() ? 114 : 84;
    $(`.${announcementClass}`).removeClass(`${announcementClass}`);
    $(`#${announcementBarId}`).remove();

    $('.navigation').css({
      height: setNavHeight,
      'padding-top': '0',
    });
    // Save preference to sessionStorage
    sessionStorage.setItem('hiddenAnnouncementBar', 'true');
  }

  /*
   * Transparent Handler
   *
   */
  function transparentHandler() {
    const applyTransparentHandling = isTransparentPage();
    if (applyTransparentHandling) {
      applyTransparent();
      $navigation.on('mouseenter', removeTransparent);
      $navigation.on('mouseleave', applyTransparent);
      window.addEventListener('scroll', heroPastHandler, false);
      return;
    }
    removeTransparent();
    $navigation.off('mouseenter', removeTransparent);
    $navigation.off('mouseleave', applyTransparent);
    window.removeEventListener('scroll', heroPastHandler, false);
  }

  function qabZIndex() {
    return $('body #qab_background').length > 0
      ? $('body #qab_background').css('z-index', '1')
      : false;
  }

  $(window).on(
    'load resize scroll',
    custom.utils.debounce(() => {
      announcementBarHeight = $('.announcement-bar').length
        ? $('.announcement-bar').height()
        : 0;
      position = $(window).scrollTop();
      qabZIndex();
    }, 100),
  );

  function hideAllAnnouncements() {
    const setNavHeight = !isMobile() ? 114 : 84;
    $('.has-announcement #announcementBar').hide();
    if ($('#qab_bar').length > 0) $('#qab_bar').hide();

    $('.navigation').css({
      height: setNavHeight,
      'padding-top': '0',
      top: '0',
    });
  }

  function showAllAnnouncements() {
    const setNavHeight = !isMobile() ? 114 : 84;
    if (position == 0) {
      $('.has-announcement #announcementBar').show();
      $('.has-announcement .navigation').css(
        'padding-top',
        announcementBarHeight,
      );
      $('.has-announcement .navigation').css(
        'height',
        announcementBarHeight + setNavHeight,
      );
    } else {
      $('.navigation').css('height', setNavHeight);
      $('.navigation').css('padding-top', 0);
    }
    if ($('#qab_bar').length > 0 && position == 0) {
      $('#qab_bar').show();
      $('.navigation').css('top', 'auto');
    }
  }

  function isMobile() {
    return $(window).width() < breakpoint;
  }

  function announcementHeightHandler() {
    $(window).on(
      'load resize scroll',
      custom.utils.debounce(() => {
        const setNavHeight = !isMobile() ? 114 : 84;
        if (
          $('body').hasClass('js-scroll-direction-down') &&
          $(window).scrollTop() > 0
        ) {
          $('.has-announcement #announcementBar').hide();
          $('.navigation').css('top', 0);
          $('.navigation').css('padding-top', 0);

          $('.navigation').css('height', setNavHeight);
        } else if (
          $('body').hasClass('js-scroll-direction-up') &&
          $(window).scrollTop() > 0
        ) {
          $('.has-announcement .navigation').css('padding-top', 0);
          $('.has-announcement .navigation').css('height', setNavHeight);
          $('.has-announcement .navigation').css('top', 0);
        } else {
          $('.has-announcement #announcementBar').show();
          $('.navigation').css('top', 'auto');
          $('.has-announcement .navigation').css(
            'padding-top',
            announcementBarHeight,
          );
          $('.has-announcement .navigation').css(
            'height',
            announcementBarHeight + setNavHeight,
          );
          if ($('#qab_bar').length > 0) {
            $('.has-announcement .navigation').css(
              'top',
              $('#qab_container').height(),
            );
            $('#qab_bar').show();
          }
        }
      }, 100),
    );
  }

  function cyclePromoMessage($targetMessage) {
    let $nextSibling = $targetMessage.next();
    if ($nextSibling.length <= 0) {
      $nextSibling = $targetMessage.siblings().first();
    }
    if ($nextSibling.length <= 0) {
      return;
    }
    $targetMessage
      .addClass('js-util-promo-message--inactive')
      .removeClass('js-util-promo-message--active');
    $nextSibling
      .addClass('js-util-promo-message--active')
      .removeClass('js-util-promo-message--inactive');
    const waitDuration = $nextSibling.data('display-length') || 5000;
    setTimeout(() => {
      cyclePromoMessage($nextSibling);
    }, waitDuration);
  }

  function promoMessageHandler() {
    const $promoMessageContainer = $('.js-util-promo-container');
    const $promoMessageContainerMobile = $('.js-util-promo-container-mobile');
    const $desktopPromoMessages = $promoMessageContainer.children(
      '.js-util-promo-message',
    );
    const $mobilePromoMessages = $promoMessageContainerMobile.children(
      '.js-util-promo-message',
    );
    if ($desktopPromoMessages.length > 1 && $mobilePromoMessages.length > 1) {
      const $activeMessage = $desktopPromoMessages.first();
      const $activeMessageMobile = $mobilePromoMessages.first();
      const waitDuration = $activeMessage.data('display-length') || 5000;
      setTimeout(() => {
        cyclePromoMessage($activeMessage);
        cyclePromoMessage($activeMessageMobile);
      }, waitDuration);
    }
  }

  function init() {
    // Check if announcement bar exists and if it should be hidden
    checkAnnouncementBar();
    announcementHeightHandler();
    promoMessageHandler();

    $triggers.on('click mouseenter', openChildPanel);
    $('.navigation__primary-link')
      .not('.navigation__link--has-sub')
      .on('mouseover', () => {
        closeDropDown();
        $('.navigation__primary-link.navigation__link--has-sub > a').addClass(
          primaryLinkBlurClass,
        );
        $utilitiesLinks.addClass(utilitiesLinkBlurClass);
      });

    collaborationLink();

    $(document).on('click', '.js-search-filter-open', () => {
      hideAllAnnouncements();
    });
    $(document).on('click', '.js-bodyclass-toggle-close', () => {
      showAllAnnouncements();
    });
    $(document).on('click', '.js-login-form-trigger', () => {
      qabZIndex();
    });

    let closeTimeout;
    $primaryLinks.on('click mouseenter', function () {
      primaryLinkColorHandler;
      clearTimeout(closeTimeout);
    });
    $primaryLinks.on('mouseleave', function () {
      closeTimeout = setTimeout(closeDropDown, 300);
    });
    $('.navigation__secondary').on('mouseenter', function () {
      clearTimeout(closeTimeout);
    });
    $('.navigation__secondary').on('mouseleave', function () {
      closeTimeout = setTimeout(closeDropDown, 300);
    });
    $navigation.each((_, el) => {
      el.addEventListener('wheel', containDropdownWheel, { passive: false });
    });
    $navigation.find('.navigation__hamburger').on('click', togglePanel);
    $navigation.find('.navigation__mobile-close').on('click', togglePanel);

    $('.js-login-form-trigger').on('click', closePanel);
    $('.js-search-panel-trigger').on('click', closePanel).bind(this);

    $(document).on('click', '.mfp-close', () => {
      showAllAnnouncements();
      unlockBodyScroll();
    });

    $('.js-search-panel-close').on('click', unlockBodyScroll);
    let orders;
    $(`.${utilNavClass}`).on('mouseenter', function () {
      orders = false;
      utilDropdownHandler(orders);
    });
    $(`.${utilNavClass}`).on('mouseleave', function () {
      orders = false;
      closeUtilDropdown(orders);
    });
    $(`.${utilNavClassOrders}`).on('mouseenter', function () {
      orders = true;
      utilDropdownHandler(orders);
    });
    $(`.${utilNavClassOrders}`).on('mouseleave', function () {
      orders = true;
      closeUtilDropdown(orders);
    });
    $utilitiesLinks.on('mouseenter', () => {
      if (!isMobile()) {
        $primaryLinks.addClass(primaryLinkBlurClass);
        $utilitiesLinks.addClass(utilitiesLinkBlurClass);
      }
    });
    $utilitiesLinks.on('mouseleave', () => {
      $primaryLinks.removeClass(primaryLinkBlurClass);
      $utilitiesLinks.removeClass(utilitiesLinkBlurClass);
    });

    $('.js-quick-cart-view-button').on('mouseenter', closeNavAndUtilDropdown);

    $(`.${backBtnClass}`).on('click', backToPrevPanel);

    window.addEventListener(
      'scroll',
      custom.utils.debounce(closeNavAndUtilDropdown, 100),
      false,
    );

    window.addEventListener(
      'resize',
      custom.utils.debounce(closeNavAndUtilDropdown, 100),
      false,
    );

    transparentHandler();

    window.addEventListener(
      'resize',
      custom.utils.debounce(() => {
        transparentHandler();
      }, 100),
      false,
    );
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/navigation.js